<template>
    <div class="container">
        <div class="im-produnc-head">
            <img class="im-logo" src="../../assets/im/im.png" title="im" />
            <span class="im-text">IM即时通讯</span>
        </div>
        <div class="im-produnc-box">
            <div class="im-produnc-kong"></div>
            <div class="im-produnc-content">
                <div class="im-produnc-title wow fadeInUp">SHALL BUY IM即时通讯工具</div>
                <div class="im-produnc-text wow fadeInUp">助您打造专属店铺</div>
                <div style="animation-delay: .3s;" class="im-text2 wow fadeInUp">
                    <p>一站式商家工作台，覆盖全链路商家经营场景，</p>
                    <p>专注服务于销巴商家，满足商家全场景经营诉求</p>
                </div>
                <div style="animation-delay: .4s;" class="im-text2 wow fadeInUp">
                    <p>会员、商家、客服可提供不同的聊天服务，</p>
                    <p>让您在聊天中随时随地切换身份，工作生活两不误</p>
                </div>
                <div class="im-produnc-link-list wow fadeInUp">
                    <div class="link-list-item">
                        <img src="../../assets/im/mobile/checked.png" />
                        <span class="link">Windows</span>
                    </div>
                    <div class="link-list-item">
                        <img src="../../assets/im/mobile/checked.png" />
                        <span class="link">BigSur</span>
                    </div>
                    <div class="link-list-item">
                        <img src="../../assets/im/mobile/checked.png" />
                        <span class="link">Monterey</span>
                    </div>
                </div>
            </div>
        </div>
        <div id="pc_btn" class="go-pc-btn" data-wow-delay="1s" @click="goPc">
            <img src="../../assets/im/mobile/pc.png" alt="">
            <span>前往pc端下载</span>
        </div>
        <div class="im-chat-content">
            <div class="im-title wow fadeInUp">
                <div class="im-chat-title">IM即时通讯工具</div>
                <div class="im-chat-title">让聊天 <div class="title-skew">体验更美好</div></div>
            </div>
            <div class="im-chat-list">
                <div class="im-chat-list-item wow fadeInUp">
                    <img src="../../assets/im/mobile/chat1-1.png" alt="">
                    <div class="item-title">多种聊天方式，沟通更便捷</div>
                    <div class="item-line"></div>
                    <div class="item-text">支持pc、app、小程序聊天同步活动</div>
                    <div class="item-text">任何端口都畅聊无阻</div>
                </div>
                <div class="im-chat-list-item wow fadeInUp">
                    <img src="../../assets/im/mobile/chat2-2.png" alt="">
                    <div class="item-title">体验多元化互动玩法更美好</div>
                    <div class="item-line"></div>
                    <div class="item-text">支持群聊天、1v1聊天，群消息@功能</div>
                    <div class="item-text">引用功能，随时随地呼唤好友</div>
                </div>
                <div class="im-chat-list-item wow fadeInUp">
                    <img src="../../assets/im/mobile/chat3-3.png" alt="">
                    <div class="item-title">多安全举措，让您的聊天更安全</div>
                    <div class="item-line"></div>
                    <div class="item-text">私密加载聊天技术，快速多重安全验证</div>
                    <div class="item-text">机制，保证会话安全，传输更快速</div>
                </div>
            </div>
        </div>
        <div class="im-chat-typebox">
            <div class="im-title">
                <div class="im-chat-title"><div class="title-skew">多种身份</div>随意切换</div>
                <div class="im-chat-title">工作生活两不误</div>
            </div>
            <div class="im-chat-typebox1 wow fadeInUp">
                
                <div class="typebox-head">
                    <div class="typebox-head-title">会员身份</div>
                    <div class="typebox-head-line"></div>
                    <div class="typebox-head-text">与您的好友尽情畅聊，发送表情、文件</div>
                    <div class="typebox-head-text">图片、视频、语音、引用等多重体验</div>
                </div>
                <svg
                    viewBox="0 0 375 351"
                    version="1.1" xmlns="http://www.w3.org/2000/svg"
                    xmlns:xlink="http://www.w3.org/1999/xlink">
                    <image xlink:href="../../assets/im/mobile/chat_type1.png" x="92" y="0" width="255" height="269"/>
                    <g>
                        <circle r="2.5" cx="154" cy="84"></circle>
                        <polyline points="152,84 96,84" />
                        <image xlink:href="../../assets/im/mobile/tag1.png" x="17" y="63" width="91" height="50"/>
                    </g>
                    <g>
                        <circle r="2.5" cx="150" cy="124"></circle>
                        <polyline points="150,126 150,192 194,192 194,268" />
                        <image xlink:href="../../assets/im/mobile/tag2.png" x="152" y="258" width="91" height="50"/>
                    </g>
                    <g>
                        <circle r="2.5" cx="142" cy="205"></circle>
                        <polyline points="142,203 142,141 92,141" />
                        <image xlink:href="../../assets/im/mobile/tag3.png" x="17" y="120" width="91" height="50"/>
                    </g>
                    <g>
                        <circle r="2.5" cx="126" cy="224"></circle>
                        <polyline points="126,226 126,305" />
                        <image xlink:href="../../assets/im/mobile/tag4.png" x="80" y="297" width="91" height="50"/>
                    </g>
                    <image xlink:href="../../assets/im/mobile/tag5.png" x="200" y="203" width="44" height="44"/>
                    <text x="215" y="247" font-size="6">图片</text>
                    <image xlink:href="../../assets/im/mobile/tag6.png" x="236" y="203" width="44" height="44"/>
                    <text x="251" y="247" font-size="6">视频</text>
                </svg>
            </div>
            <div class="im-chat-typebox2 wow fadeInUp">
                <div class="typebox-head">
                    <div class="typebox-head-title">商户身份</div>
                    <div class="typebox-head-line"></div>
                    <div class="typebox-head-text">高效解决客户疑问，一键查询</div>
                    <div class="typebox-head-text">客户所购买的商品订单详情</div>
                </div>
                <svg
                    viewBox="0 0 375 403"
                    version="1.1" xmlns="http://www.w3.org/2000/svg"
                    xmlns:xlink="http://www.w3.org/1999/xlink">
                    <image xlink:href="../../assets/im/mobile/chat_type2-2.png" x="62" y="145" width="313" height="214"/>
                    <image xlink:href="../../assets/im/mobile/chat_type2.png" x="35" y="0" width="262" height="403"/>
                    <g>
                        <circle r="2.5" cx="69" cy="138"></circle>
                        <polyline points="69,136 69,106 307,106 307,73" />
                        <image xlink:href="../../assets/im/mobile/tag7.png" x="261" y="44" width="91" height="51"/>
                    </g>
                </svg>
            </div>
            <div class="im-chat-typebox3 wow fadeInUp">
                <div class="typebox-head">
                    <div class="typebox-head-title">客服身份</div>
                    <div class="typebox-head-line"></div>
                    <div class="typebox-head-text">高效一键发送高频常用语、常用链接</div>
                    <div class="typebox-head-text">常用文件，为您排忧解难</div>
                </div>
                <svg
                    viewBox="0 0 375 450"
                    version="1.1" xmlns="http://www.w3.org/2000/svg"
                    xmlns:xlink="http://www.w3.org/1999/xlink">
                    <image xlink:href="../../assets/im/mobile/chat_type3.png" x="22" y="0" width="269" height="369"/>
                    <g>
                        <circle r="2.5" cx="120" cy="101"></circle>
                        <polyline points="120,105 307,105 307,145" />
                        <image xlink:href="../../assets/im/mobile/tag8.png" x="260" y="141" width="100" height="39"/>
                    </g>
                    <g>
                        <circle r="2.5" cx="43" cy="235"></circle>
                        <polyline points="45,235 212,235 212,392" />
                        <image xlink:href="../../assets/im/mobile/tag9.png" x="168" y="380" width="91" height="51"/>
                    </g>
                </svg>
            </div>
        </div>
        <div class="im-swiper-container wow fadeInUp">
            <div class="im-title">
                <div class="im-chat-title"><div class="title-skew">一体化</div>的操作体验</div>
            </div>
            <div class="im-swiper-text">
                <div>优化工作台菜单与界面 </div>
                <div>为商家提供简洁高效的经营体验</div>
            </div>
            <div class="im-swiper-box">
                <swiper class="swiper" ref="mySwiper" :options="swiperOption">
                    <swiper-slide>
                        <div :class="{'swpier-pic-item': true, focus: swiper_idx === 0}"><img src="../../assets/im/swiper3.png" alt=""></div>
                    </swiper-slide>
                    <swiper-slide>
                        <div :class="{'swpier-pic-item': true, focus: swiper_idx === 1}"><img src="../../assets/im/swiper2.png" alt=""></div>
                    </swiper-slide>
                    <swiper-slide>
                        <div :class="{'swpier-pic-item': true, focus: swiper_idx === 2}"><img src="../../assets/im/swiper1.png" alt=""></div>
                    </swiper-slide>
                </swiper>
            </div>
            <div class="progress-container animate__animated animate__fadeInUp">
                <div class="progress-bar-box">
                    <div class="progress-bar-persent" :style="{ left: swiper_index + '%' }"></div>
                </div>
            </div>
        </div>
        <div class="im-video wow fadeInUp">
            <img class="decorate-pic1" src="../../assets/im//mobile/video1.png">
            <img class="decorate-pic2" src="../../assets/im/mobile/video2.png">
            <div class="im-video-title animate__animated animate__fadeInUp">爽快的<div class="title-skew">双向收发</div>体验</div>
            <div class="im-video-text animate__animated animate__fadeInUp">
                <div>通过IM</div>
                <div>电脑和手机上的文件都能收发自如</div>
                <div>轻松你的工作和生活</div>
            </div>
            <img class="video-decorate-bg" src="../../assets/im/mobile/video_bg2.png" alt="">
            <div class="im-video-box">
                <video id="video" :controls="!pause" ref="videoRef" src="../../assets/im/im.mp4" @click="videoClick" @ended="onended"></video>
                <div v-show="pause" class="im-video-bf" @click="videoClick">
                    <img src="../../assets/im/logo2.png" alt="">
                    <div class="video-text">
                        <div class="video-text1">操作指南</div>
                        <div class="video-text-line"></div>
                        <div class="video-text2">带您了解即时通讯</div>
                    </div>
                    <div class="video-text-en">instructions Introduce you to instant messaging</div>
                </div>
                <img v-show="pause" src="../../assets/im/mobile/video_decorate.png" class="im-video-decorate" />
            </div>
            <div class="qipao-item qipao-item1">
                <img src="../../assets/im/voice.svg" alt=""><span>15s</span>
            </div>
            <div class="qipao-item qipao-item2">
                <img src="../../assets/im/voice.svg" alt=""><span>15s</span>
            </div>
            <div class="qipao-item qipao-item3">
                <img src="../../assets/im/voice.svg" alt=""><span>15s</span>
            </div>
            <div class="qipao-item qipao-item4">
                <img src="../../assets/im/voice.svg" alt=""><span>15s</span>
            </div>
            <div class="qipao-item qipao-item5">
                <img src="../../assets/im/voice.svg" alt=""><span>15s</span>
            </div>
            <div class="qipao-item qipao-item6">沟通，是联络感情的纽带</div>
            <div class="qipao-item qipao-item7">沟通，是通向友谊的桥梁</div>
            <div class="qipao-item qipao-item8">沟通是人类恒古不变的梦想，IM为您架起桥备份</div>
        </div>
        <div class="im-footer wow fadeInUp">
            <div class="footer-title">关注销巴生活</div>
            <div class="footer-code">
                <div class="footer-code-line"></div>
                <div>
                    <img src="../../assets/im/mobile/xb_gzh.png" alt="">
                    <div class="code-text">关注销巴生活</div>
                    <div class="code-text">微信公众号</div>
                </div>
                <div>
                    <img src="../../assets/im/mobile/xb_app.png" alt="">
                    <div class="code-text">下载销巴生活APP</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { WOW } from "wowjs";
let observer = null;
const page_name = "immobile";
export default {
    name: "IMMobile",
    data() {
        return {
            pause: true,
            routered: false,
            swiper_index: 36,
            swiper_idx: 1,
            swiperOption: {
                initialSlide: 1,
                grabCursor: true,
                centeredSlides: true,
                slidesPerView: 'auto',
                on: {
                    //监听滑动切换事件，返回swiper对象
                    slideChange: () => {
                        let swiper = this.$refs.mySwiper.$swiper;
                        if (swiper) {
                            this.swiper_index = 36 * swiper.activeIndex;
                            this.swiper_idx = swiper.activeIndex;
                        }
                        
                    }
                }
            }
        }
    },
    methods: {
        videoClick(){
            if(this.pause){
                this.pause = false;
                this.$refs.videoRef.play();
            }else{
                this.pause = true;
                this.$refs.videoRef.pause();
            }
        },
        onended(){
            this.pause = true;
        },
        goPc(){
            this.$router.push("/im/pc");
        },
        setHtmlFontSize() {
            if (document.documentElement.clientWidth >= 960 && page_name === "immobile" && !this.routered) {
                this.routered = true;
                this.goPc();
            }
        },
        changeFavicon() {
            let link = document.querySelector("link[rel*='icon']") || document.createElement('link');
            if (link) {
                link.type = 'image/x-icon';
                link.rel = 'shortcut icon';
                link.href = "/im.ico";
                document.getElementsByTagName('head')[0].appendChild(link);
            }
        }
    },
    mounted() {
        this.routered = false;
        this.changeFavicon();
        // const other = document.getElementById("cert_show_img");
        // other && (other.parentElement.parentElement.style.display = "none");
        // document.getElementsByClassName("bg-color")[0].style.display = "none";
        // document.getElementsByClassName("footer")[0].style.display = "none";
        this.$nextTick(() => { // 在dom渲染完后,再执行动画
            new WOW().init();
        });
        window.addEventListener("resize", this.setHtmlFontSize, false);
        observer = new IntersectionObserver((e)=> {
            e.forEach((item)=> {
                if (item.target.id === "video" && item.intersectionRatio < 0.8) {
                    this.pause || this.videoClick();
                }
            });
        }, {
            threshold: [0.8]
        });
        observer.observe(document.getElementById("video"));
    },
    beforeDestroy(){
        observer && observer.disconnect();
         window.removeEventListener("resize", this.setHtmlFontSize);
    },
    // beforeRouteEnter (to, from, next) {
    //     // const other = document.getElementById("cert_show_img");
    //     // other && (other.parentElement.parentElement.style.display = "none");
    //     // document.getElementsByClassName("bg-color")[0].style.display = "none";
    //     next();
    // }
}
</script>

<style lang="less" scoped>
@keyframes strok {
    100% {
        stroke-dashoffset: 0;
    }
}
video::-webkit-media-controls-mute-button {
	display: none!important;            
}
img{
    display: block;
}
svg {
    circle{
        fill: #1560FA; 
        stroke: rgba(21, 96, 250, 0.2);
        stroke-width: 4;
    }
    polyline{
        fill: transparent; 
        stroke: #b6cdfe; 
        stroke-width: 1;
        stroke-dasharray: 2;
    }
    
}
.container{
    width: 100%;
    overflow: hidden;
    background-color: #fff;
}
.im-title{
    .im-chat-title{
        display: flex;
        justify-content: center;
        font-size: 22px;
        font-family: PingFang SC-Heavy, PingFang SC;
        font-weight: 800;
        color: #050029;
        line-height: 36px;
        letter-spacing: 1px;
    }
    .title-skew {
        position: relative;
        &::after {
            position: absolute;
            content: "";
            bottom: 0;
            left: 0;
            width: 100%;
            height: 3px;
            transform: skewX(-45deg);
            background-color: #b2ccff;
        }
    }
}
    .im-produnc-title {
        margin-top: 24px;
        font-size: 24px;
        font-family: PingFang SC-Semibold, PingFang SC;
        font-weight: 600;
        color: #333333;
        line-height: 36px;
        text-align: center;
    }

    .im-produnc-head {
        position: fixed;
        left: 0;
        top: 0;
        display: flex;
        align-items: center;
        padding-left: 15px;
        width: 100vw;
        height: 44px;
        background-color: #fff;
        border-bottom: 1px solid rgba(0, 0, 0, 0.04);
        z-index: 999;
        .im-logo {
            width: 21px;
            height: 21px;
        }

        .im-text {
            font-size: 14px;
            margin-left: 8px;
            font-family: PingFang SC-Medium, PingFang SC;
            font-weight: 500;
            color: #1660fa;
            line-height: 21px;
        }
    }
    .im-produnc-box{
        display: flex;
        flex-direction: column;
        height: 100vh;
    }
    .im-produnc-content {
        flex: 1;
        display: flex;
        flex-direction: column;
        align-items: center;
        margin-top: 66px;
        padding-top: 96px;
        background: url("../../assets/im/mobile/bg1.png");
        background-position: top left;
        background-size: 100% 100%;
        background-repeat: no-repeat;
        .im-produnc-kong{
            height: 44px;
        }
        .im-produnc-text {
            margin-top: 24px;
            font-size: 18px;
            font-family: PingFang SC-Medium, PingFang SC;
            font-weight: 500;
            color: #333333;
            line-height: 21px;
            animation-delay: .2s;
        }

        .im-text2 {
            margin-top: 12px;
            font-size: 14px;
            font-family: PingFang SC-Regular, PingFang SC;
            font-weight: 400;
            color: #333333;
            line-height: 24px;
            text-align: center;
        }

        .im-produnc-link-list {
            display: flex;
            margin-top: 24px;
            animation-delay: .6s;

            .link-list-item {
                display: flex;
                align-items: center;
                &:nth-of-type(2) {
                    margin: 0 19px;
                }
            }

            img {
                width: 14px;
                height: 14px;
                margin-right: 4px;
            }

            span {
                font-size: 14px;
                font-family: PingFang SC-Regular, PingFang SC;
                font-weight: 400;
                color: #6798FF;
                line-height: 16px;
            }
        }

    }
    .go-pc-btn{
        position: fixed;
        display: flex;
        align-items: center;
        justify-content: center;
        left: 50%;
        bottom: 32px;
        transform: translateX(-50%);
        width: 205px;
        height: 45px;
        background: linear-gradient(93deg, #021DF7 0%, #1A6EFF 100%);
        border-radius: 88px 88px 88px 88px;
        z-index: 998;
        img{
            margin-right: 8px;
            width: 21px;
            height: 19px;
        }
        span{
            font-size: 15px;
            font-family: PingFang SC-Medium, PingFang SC;
            font-weight: 500;
            color: #FFFFFF;
            line-height: 18px;
        }
    }
    .im-chat-content{
        display: flex;
        flex-direction: column;
        align-items: center;
        padding-top: 41px;
        height: 1209px;
        background: url("../../assets/im/mobile/im_chat_bg.png");
        background-position: top left;
        background-size: 100% 100%;
        background-repeat: no-repeat;
        .im-chat-list{
            display: flex;
            flex-direction: column;
            justify-content: center;
            text-align: center;
            margin-top: 101px;
            .im-chat-list-item{
                position: relative;
                display: flex;
                flex-direction: column;
                justify-content: flex-end;
                align-items: center;
                width: 300px;
                height: 246px;
                padding-bottom: 29px;
                border-radius: 16px;
                box-shadow: 8px 8px 40px 1px rgba(17, 96, 250, .08);
                img{
                    position: absolute;
                    top: -51px;
                    left: 86px;
                    width: 128px;
                    height: 128px;
                }
                &:nth-of-type(1){
                    background: url("../../assets/im/mobile/chat1.png");
                    background-position: top left;
                    background-size: 100% 100%;
                    background-repeat: no-repeat;
                }
                &:nth-of-type(2){
                    margin-top: 98px;
                    background: url("../../assets/im/mobile/chat2.png");
                    background-position: top left;
                    background-size: 100% 100%;
                    background-repeat: no-repeat;
                }
                &:nth-of-type(3){
                    margin-top: 98px;
                    background: url("../../assets/im/mobile/chat3.png");
                    background-position: top left;
                    background-size: 100% 100%;
                    background-repeat: no-repeat;
                    
                }
            }
            .item-title{
                font-size: 17px;
                font-family: PingFang SC-Semibold, PingFang SC;
                font-weight: 600;
                color: #333333;
                line-height: 36px;
            }
            .item-text{
                font-size: 15px;
                font-family: PingFang SC-Regular, PingFang SC;
                font-weight: 400;
                color: #333333;
                line-height: 28px;
            }
            .item-line{
                margin-top: 6px;
                margin-bottom: 18px;
                width: 78px;
                height: 3px;
                background-color: rgba(125, 168, 255, 0.1);
                border-radius: 99px 99px 99px 99px;
            }
        }
    }
    .im-chat-typebox{
        display: flex;
        flex-direction: column;
        align-items: center;
        height: 2008px;
        padding-top: 44px;
        background: url("../../assets/im/mobile/chat_type.png");
        background-position: top left;
        background-size: 100% 100%;
        background-repeat: no-repeat;
        .typebox-head{
            display: flex;
            flex-direction: column;
            align-items: center;
            .typebox-head-title{
                font-size: 17px;
                font-family: PingFang SC-Semibold, PingFang SC;
                font-weight: 600;
                color: #1560FA;
                line-height: 36px;
            }
            .typebox-head-line{
                margin-bottom: 18px;
                width: 20px;
                height: 3px;
                background: #1560FA;
                border-radius: 99px 99px 99px 99px;
            }
            .typebox-head-text{
                font-size: 15px;
                font-family: PingFang SC-Regular, PingFang SC;
                font-weight: 400;
                color: #333333;
                line-height: 24px;
                text-align: center;
            }
        }
        .im-chat-typebox1{
            margin-top: 40px;
            svg{
                margin-top: 36px;
                height: 351px;
                width: 375px;
            }
        }
        .im-chat-typebox2{
            margin-top: 104px;
            svg{
                margin-top: 36px;
                height: 403px;
                width: 375px;
            }
        }
        .im-chat-typebox3{
            margin-top: 104px;
            svg{
                margin-top: 36px;
                height: 450px;
                width: 375px;
            }
        }
    }
    .im-swiper-container{
        width: 100vw;
        height: 471px;
        padding-top: 64px;
        background: url("../../assets/im/mobile/swiper_bg.png");
        background-position: top left;
        background-size: 100% 100%;
        background-repeat: no-repeat;
        .im-swiper-text{
            margin-top: 18px;
            font-size: 15px;
            font-family: PingFang SC-Regular, PingFang SC;
            font-weight: 400;
            color: #000000;
            line-height: 24px;
            text-align: center;
        }
        .im-swiper-box{
            margin-top: 48px;
            width: 100vw;
            height: 190px;
            overflow: visible;
        }
        .swiper{
            height: 190px;
            width: 100%;
            overflow: visible;
            .swiper-slide {
                width: 306px;
                margin: 0 8.5px;
                height: 190px;
                box-shadow: 0 2px 10px 0 rgba(21, 96, 250, 0.12);
                 .swpier-pic-item {
                    height: 190px;
                    border-radius: 4px;
                    overflow: hidden;
                    opacity: 0.5;
                    
                    transition: opacity .5s;
                    img{
                        width: 100%;
                        height: 100%;
                    }
                }
                .focus{
                    opacity: 1;
                }
            }
        }
        .progress-container {
            display: flex;
            justify-content: center;
            margin-top: 22px;

            .progress-bar-box {
                position: relative;
                width: 50px;
                height: 1px;
                background-color: #EAEAEA;
            }

            .progress-bar-persent {
                position: absolute;
                bottom: 0;
                left: 0;
                width: 14px;
                height: 3px;
                background-color: #1560FA;
                transition: left .5s;
            }
        }
    }
     @keyframes videop {
        0% {
            transform: translateX(0);
        }
        98%{
            opacity: 0.5;
        }
        100% {
            opacity: 1;
            transform: translateX(100vw);
        }
    }
    .im-video{
        position: relative;
        width: 100vw;
        height: 635px;
        background: url("../../assets/im/mobile/video_bg.png");
        background-position: top left;
        background-size: 100% 100%;
        background-repeat: no-repeat;
        .video-decorate-bg{
            position: absolute;
            top: 269px;
            left: 50%;
            transform: translateX(-50%);
            width: 297px;
            height: 189px;
        }
        .decorate-pic1{
            position: absolute;
            top: 117px;
            right: 0;
            width: 36px;
            height: 45px;
        }
        .decorate-pic2{
            position: absolute;
            top: 54px;
            left: 6px;
            width: 40px;
            height: 37px;
        }
        .im-video-title{
            display: flex;
            justify-content: center;
            position: absolute;
            top: 44px;
            left: 0;
            width: 100vw;
            font-size: 22px;
            font-family: PingFang SC-Heavy, PingFang SC;
            font-weight: 800;
            color: #050029;
            line-height: 36px;
            .title-skew {
                position: relative;
                &::after {
                    position: absolute;
                    content: "";
                    bottom: 0;
                    left: 0;
                    width: 100%;
                    height: 3px;
                    transform: skewX(-45deg);
                    background-color: #b2ccff;
                }
            }
        }
        .im-video-text{
            position: absolute;
            top: 99px;
            left: 0;
            width: 100vw;
            font-size: 15px;
            font-family: PingFang SC-Regular, PingFang SC;
            font-weight: 400;
            color: #000000;
            line-height: 24px;
            text-align: center;
        }
        .im-video-box{
            position: absolute;
            top: 266px;
            left: 50%;
            transform: translateX(-50%);
            width: 293px;
            height: 165px;
            background-color: #fff;
            box-shadow: 0px 8px 20px 1px rgba(0, 0, 0, 0.1);
            border-radius: 16px 16px 16px 16px;
            z-index: 2;
            .im-video-decorate{
                position: absolute;
                bottom: 0;
                right: -3px;
                width: 37px;
                height: 26px;
            }
            .im-video-bf{
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: center;
                position: absolute;
                top: 0;
                left: 0;
                width: 100%;
                height: 100%;
                background: url("../../assets/im/mobile/video_mask.png");
                background-position: top left;
                background-size: 100% 100%;
                background-repeat: no-repeat;
                .video-text{
                    display: flex;
                    align-items: center;
                    margin-top: 18px;
                }
                .video-text1{
                    font-size: 16px;
                    font-family: PingFang SC-Semibold, PingFang SC;
                    font-weight: 600;
                    color: #FFFFFF;
                    line-height: 19px;
                }
                .video-text2{
                    font-size: 16px;
                    font-family: PingFang SC-Medium, PingFang SC;
                    font-weight: 500;
                    color: #FFFFFF;
                    line-height: 19px;
                }
                .video-text-line{
                    margin: 0 12px;
                    width: 1px;
                    height: 16px;
                    background-color: #DDDDDD;
                }
                .video-text-en{
                    margin-top: 2px;
                    font-size: 10px;
                    font-family: PingFang SC-Medium, PingFang SC;
                    font-weight: 500;
                    color: rgba(255, 255, 255, 0.6);
                    line-height: 11px;
                    // letter-spacing: -0.2px;
                    transform: scale(0.8);
                }
                img{
                    width: 29px;
                    height: 29px;
                }
            }
            video{
                width: 100%;
                height: 100%;
                border-radius: 16px 16px 16px 16px;
                object-fit: cover;
            }
        }
        .qipao-item{
            position: absolute;
            display: flex;
            justify-content: center;
            align-items: center;
            background: rgba(255, 255, 255, 0.8);
            box-shadow: 0px 8px 16px 1px rgba(22, 96, 250, 0.06);
            z-index: 1;
            color: rgba(22, 96, 250, 0.5);
            &:hover {
                animation-play-state: paused;
            }
        }
        .qipao-item1{
            justify-content: space-between;
            top: 211px;
            left:10px;
            width: 120px;
            height: 33px;
            padding: 0 12px;
            border-radius: 32px 32px 32px 32px;
            font-size: 12px;
            animation: videop 20s infinite linear;
            img{
                width: 16px;
                height: 12px;
            }
        }
        .qipao-item2{
            justify-content: space-between;
            top: 220px;
            right: 49px;
            width: 91px;
            height: 27px;
            padding: 0 8px;
            border-radius: 32px 32px 32px 32px;
            font-size: 10px;
            animation: videop 20s infinite linear;
            img{
                width: 16px;
                height: 12px;
            }
        }
        .qipao-item3{
            justify-content: space-between;
            top: 292px;
            left: -53px;
            width: 91px;
            height: 27px;
            padding: 0 8px;
            border-radius: 32px 32px 32px 32px;
            font-size: 10px;
            animation: videop 24s infinite linear;
            img{
                width: 16px;
                height: 12px;
            }
        }
        .qipao-item4{
            justify-content: space-between;
            top: 340px;
            left: 4px;
            width: 99px;
            height: 31px;
            padding: 0 8px;
            border-radius: 32px 32px 32px 32px;
            font-size: 12px;
            animation: videop 20s infinite linear;
            img{
                width: 15px;
                height: 11px;
            }
        }
        .qipao-item5{
            justify-content: space-between;
            top: 367px;
            right: -60px;
            width: 91px;
            height: 27px;
            padding: 0 8px;
            border-radius: 32px 32px 32px 32px;
            font-size: 10px;
            animation: videop 25s infinite linear;
            img{
                width: 16px;
                height: 12px;
            }
        }
        .qipao-item6{
            justify-content: center;
            bottom: 113px;
            left: 10px;
            width: 179px;
            height: 42px;
            border-radius: 41px 18px 0px 41px;
            font-size: 13px;
            animation: videop 35s infinite linear;
        }
        .qipao-item7{
            justify-content: center;
            bottom: 108px;
            right: -37px;
            width: 179px;
            height: 42px;
            border-radius: 41px 18px 0px 41px;
            font-size: 13px;
            animation: videop 40s infinite linear;
        }
        .qipao-item8{
            justify-content: center;
            bottom: 48px;
            left: 17px;
            width: 330px;
            height: 44px;
            border-radius: 41px 18px 0px 41px;
            font-size: 14px;
            animation: videop 40s infinite linear;
        }
    }
    .im-footer{
        width: 100vw;
        height: 424px;
        padding-top: 44px;
        padding: 44px 31px 0 31px;
        .footer-title{
            font-size: 22px;
            font-family: PingFang SC-Semibold, PingFang SC;
            font-weight: 600;
            color: #050029;
            line-height: 36px;
            text-align: center;
        }
        .footer-code{
            position: relative;
            display: flex;
            justify-content: space-between;
            margin-top: 36px;
            .footer-code-line{
                position: absolute;
                top: 20px;
                left: 50%;
                width: 0.5px;
                height: 143px;
                background-color: rgba(0, 0, 0, 0.04);
                transform: scaleX(0.5);
            }
            .code-text{
                font-size: 13px;
                font-family: PingFang SC-Regular, PingFang SC;
                font-weight: 400;
                color: #333333;
                line-height: 18px;
                text-align: center;
            }
            img{
                margin-bottom: 12px;
                width: 120px;
                height: 120px;
                box-shadow: 0 0 10px 0 rgba(56, 122, 255, .14);
                border-radius: 50%;
            }
        }
    }
</style>